/* eslint-disable @typescript-eslint/no-explicit-any */
import { API } from 'aws-amplify'

import { useFetchQuery } from './useFetchQuery'
import { Participant as ParticipantApi, GetParticipantQuery } from '../API'
import { getParticipant } from '../api/queries'

type Participant = Omit<Exclude<ParticipantApi, null>, '__typename'>

interface Props {
  id: string | null | undefined
}

const useParticipantDetails = ({ id }: Props) => {
  const {
    data: participant,
    apiLoading,
    apiError,
  } = useFetchQuery(
    async () => {
      const result = API.graphql({
        query: getParticipant,
        variables: { id },
        authMode: 'AWS_IAM',
      }) as Promise<{ data: GetParticipantQuery }>

      const {
        data: { getParticipant: data },
      } = await result
      return data as Participant
    },
    [id],
    'Fail to load participant',
  )

  return { participant, apiLoading, apiError }
}

export default useParticipantDetails
